var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "company-switcher__footer" }, [
    _c(
      "button",
      {
        staticClass: "company-switcher__create",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.$emit("create")
          },
        },
      },
      [
        _c("lucide-icon", {
          staticClass: "company-switcher__create-icon",
          attrs: { icon: _vm.icons.plus, size: 16, "aria-hidden": "true" },
        }),
        _vm._v(" " + _vm._s(_vm.$t("criarnovaempresa")) + " "),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }